import LegalPageLayout from '@/components/LegalPageLayout';

const Section = ({ n, title, children }) => (
  <section className="space-y-3" data-testid={`privacy-section-${n}`}>
    <h2 className="text-2xl font-bold text-white" style={{ fontFamily: 'Outfit' }}>{n}. {title}</h2>
    <div className="space-y-3">{children}</div>
  </section>
);

const SubHeading = ({ children }) => (
  <h3 className="text-base font-semibold text-white mt-4">{children}</h3>
);

const List = ({ items }) => (
  <ul className="list-disc pl-6 space-y-1.5 text-zinc-300">
    {items.map((it, i) => <li key={i}>{it}</li>)}
  </ul>
);

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout title="Privacy Policy" lastUpdated="20-04-2026" testId="privacy-policy-page">
      <Section n={1} title="Introduction">
        <p>This Privacy Policy explains how Perfect Multimedia Global Limited ("we", "our", "us") collects, uses, and protects your information when you use the Law Agency 360 platform ("the Platform").</p>
        <p>We are committed to protecting your personal data and handling it in a transparent and secure manner.</p>
        <SubHeading>Company Details:</SubHeading>
        <div className="not-prose rounded-xl border border-white/10 bg-white/[0.03] p-4 text-sm">
          <div className="font-semibold text-white">Perfect Multimedia Global Limited</div>
          <div>51 Bracken Road, Sandyford</div>
          <div>Dublin 18, D18 CV48</div>
          <div>Company No.: 687854</div>
          <div>VAT Number: IE3761530HH</div>
        </div>
      </Section>

      <Section n={2} title="Information We Collect">
        <SubHeading>a. Personal Information</SubHeading>
        <List items={['Name', 'Email address', 'Company name', 'Contact details']} />
        <SubHeading>b. Account Information</SubHeading>
        <List items={['Login credentials', 'Subscription details', 'Billing information']} />
        <SubHeading>c. Usage Data</SubHeading>
        <List items={['Dashboard activity', 'Feature usage', 'Interaction with platform tools']} />
        <SubHeading>d. Uploaded Content</SubHeading>
        <List items={['Documents uploaded for translation', 'Website briefs and marketing inputs', 'Any files or content submitted through the platform']} />
      </Section>

      <Section n={3} title="How We Use Your Information">
        <List items={[
          'Provide and operate the platform',
          'Manage your account and subscription',
          'Process payments and billing',
          'Deliver services (SEO, content, translations, website creation, etc.)',
          'Improve platform functionality',
          'Communicate with you',
          'Ensure security'
        ]} />
      </Section>

      <Section n={4} title="Legal Basis (GDPR)">
        <List items={['Consent', 'Contract performance', 'Legal obligation', 'Legitimate interests']} />
      </Section>

      <Section n={5} title="Payments">
        <p>Payments are processed via Stripe.</p>
        <p>We do not store full card details.</p>
      </Section>

      <Section n={6} title="Data Sharing">
        <p>We may share data with:</p>
        <List items={['Service providers', 'Stripe', 'Translation vendors (only if AI + Human selected)', 'Internal team']} />
        <p>We do not sell your data.</p>
      </Section>

      <Section n={7} title="Data Security">
        <p>We implement appropriate safeguards including secure authentication and access control.</p>
      </Section>

      <Section n={8} title="Data Retention">
        <p>We retain data while your account is active or as required legally.</p>
      </Section>

      <Section n={9} title="Your Rights">
        <p>You may:</p>
        <List items={['Access your data', 'Request correction', 'Request deletion', 'Object to processing']} />
        <p>Contact: <a className="text-violet-300 hover:underline" href="mailto:lawagency360@gmail.com">lawagency360@gmail.com</a></p>
      </Section>

      <Section n={10} title="Cookies">
        <p>We use cookies for functionality and analytics.</p>
      </Section>

      <Section n={11} title="Third-Party Services">
        <p>Includes Stripe, Google Analytics, Search Console, etc.</p>
      </Section>

      <Section n={12} title="International Transfers">
        <p>Data may be processed outside your jurisdiction with safeguards.</p>
      </Section>

      <Section n={13} title="Confidentiality of Uploaded Documents">
        <p>Documents uploaded for translation or services are treated as confidential and are only accessible to authorised personnel or vendors involved in service delivery.</p>
      </Section>

      <Section n={14} title="Changes">
        <p>We may update this policy at any time.</p>
      </Section>

      <Section n={15} title="Contact">
        <div className="not-prose rounded-xl border border-white/10 bg-white/[0.03] p-4 text-sm">
          <div className="font-semibold text-white">Perfect Multimedia Global Limited</div>
          <div>51 Bracken Road, Sandyford</div>
          <div>Dublin 18, D18 CV48</div>
          <a className="text-violet-300 hover:underline" href="mailto:lawagency360@gmail.com">lawagency360@gmail.com</a>
        </div>
      </Section>
    </LegalPageLayout>
  );
}
